import * as React from 'react';

const PAGE_SIZE = 100;
const SCROLL_THRESHOLD_PX = 200;

export function useInfiniteScroll(totalRows: number) {
  const [visibleCount, setVisibleCount] = React.useState(PAGE_SIZE);
  const sentinelRef = React.useRef<HTMLDivElement>(null);

  const hasMore = visibleCount < totalRows;

  React.useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [totalRows]);

  React.useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, totalRows));
        }
      },
      { rootMargin: `${SCROLL_THRESHOLD_PX}px` },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, totalRows]);

  return { visibleCount, hasMore, sentinelRef };
}
